import { ExtractionObject } from "./stixify_api"

export const getDateString = (date: string | undefined) => {
    if (!date) return '-'
    return new Date(date).toJSON().split("T")[0]
}

export const cleanData = (data: object) => {
    const result: Object = {}
    Object.keys(data).forEach(key => {
        if (data[key] !== "") {
            result[key] = data[key]
        }
    })
    return result
}

export const getScoValue = (sco: ExtractionObject) => {
  if (sco.type === 'file') {
    if (sco.name) return sco.name
    if (sco.hashes) {
      return Object.values(sco.hashes)[0]
    }
  }
  return sco.value || sco.number || sco.iban_number || sco.name || sco.key || sco.path || sco.string || sco.address
}

export const updateURLWithParams = (params) => {
    const queryString = new URLSearchParams(params).toString();
    const newURL = `${window.location.pathname}?${queryString}`;
    window.history.pushState(null, "", newURL);
};


export const setLoginRedirectUrl = (url: string) => {
  window.sessionStorage.setItem('loginRedirectData', JSON.stringify({
    expiry: Number(new Date()) + 5 * 60 * 1000,
    url,
  }))
}

export const getLoginRedirectUrl = () => {
  const data = window.sessionStorage.getItem('loginRedirectData')
  if(!data) return
  const dataJson = JSON.parse(data)
  if (Number(new Date()) - Number(dataJson.expiry) > 0) return
  return dataJson.url;
}

export const clearLoginRedirectUrl = () => {
  window.sessionStorage.clear()
}
